// extracted by mini-css-extract-plugin
export default {"dateReviewedContainer":"CareElementDateReviewed_dateReviewedContainer__5JmTY","datePickerWrapper":"CareElementDateReviewed_datePickerWrapper__r6Z6R"};